import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import { ModalPosition } from 'components/Modal';
import { ContentWrapper } from 'components/modals/common';
import { SharedContentTable } from 'components/SharedContentTable';
import { useCourse } from 'hooks/useCourse';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  courseId: string;
  onCancel: () => void;
}

export const SearchSharedContent = (props: Props) => {
  const { data: course } = useCourse(props.courseId);
  const [currentTab, setCurrentTab] = useState(0);
  const { t } = useTranslation();

  function handleTabChange(_event: any, newValue: any) {
    setCurrentTab(newValue);
  }

  return (
    <ModalPosition top={1.5}>
      {course?.partner?.id && (
        <ContentWrapper>
          <Tabs value={currentTab} onChange={handleTabChange}>
            <Tab label={t('Shared Assignments')} />
            {course.partner.parent?.id && <Tab label={t('Parent Shared Assignments')} />}
          </Tabs>
          {currentTab === 0 && (
            <SharedContentTable
              value={currentTab}
              index={0}
              partnerId={course.partner.id}
              courseId={props.courseId}
              onCancel={props.onCancel}
              allowHardCopy={true}
            />
          )}
          {currentTab === 1 && (
            <SharedContentTable
              value={currentTab}
              index={1}
              partnerId={course.partner.parent.id}
              courseId={props.courseId}
              onCancel={props.onCancel}
              allowHardCopy={false}
            />
          )}
        </ContentWrapper>
      )}
    </ModalPosition>
  );
};
